import { axiosInstanceV1 } from "@bn/api";
import { PageableRegionList } from "../model";

export const getCountries = async () => {
  const { data } = await axiosInstanceV1.get<PageableRegionList>(`/regions`, {
    params: { type: "country" },
  });
  return data;
};
